import { render } from "./AddReview.vue?vue&type=template&id=4dbd5a02&scoped=true"
import script from "./AddReview.vue?vue&type=script&lang=js"
export * from "./AddReview.vue?vue&type=script&lang=js"

import "./review.scss?vue&type=style&index=0&id=4dbd5a02&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbd5a02"]])

export default __exports__